module.exports = __webpack_public_path__ + "img/product-preview-88.cffa511.png";